module.exports = __webpack_public_path__ + "static/img/partner-hs.71c26df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-hs.png
// module id = yEia
// module chunks = 34